import apiService from '#services/api';
import debug from '#services/debug.service';
import { GetUsersDto } from '../user/dto/get-users.dto';
import { UsersResponse } from '../user/responses/user.response';

export class UsersService {
  private API_ROUTES = {
    users: 'admin/users',
  };

  public async getUsers({
    status,
    search = '',
    role,
    ...searchParams
  }: GetUsersDto) {
    try {
      const params = new URLSearchParams();

      if (search) {
        params.append('search', search);
      }

      if (role?.length) {
        role.forEach((r) => params.append('role', r));
      }

      if (status) {
        params.append('status', status);
      }

      Object.entries(searchParams).forEach(([key, value]) => {
        if (Array.isArray(value)) {
          value.forEach((v) => params.append(key, v));
        } else {
          params.append(key, String(value));
        }
      });

      const request = await apiService.request.get(`${this.API_ROUTES.users}`, {
        headers: {
          'content-type': 'application/json',
        },
        searchParams: params,
      });

      const result: UsersResponse = await request.json();

      debug.success('🧑🏻‍💻 ~ UsersService ~ getUsers ~ result:', result);

      return result;
    } catch (err) {
      debug.error('🧑🏻‍💻 ~ UsersService ~ getUsers ~ err:', err);

      throw err;
    }
  }
}
